import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
})

async function boot() {
  // Version check — forces LINE LIFF to load fresh JS when version changes.
  // Fetches version.json from network (cache-busted), compares with localStorage.
  // If different, redirects to new URL so LINE cannot serve its cached index.html.
  try {
    const res = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store' })
    if (res.ok) {
      const { v } = await res.json() as { v: string }
      const stored = localStorage.getItem('__app_v')
      localStorage.setItem('__app_v', v)
      if (stored && stored !== v) {
        // URL change forces LINE LIFF to bypass its HTML cache
        window.location.replace('/?r=' + v)
        return
      }
    }
  } catch {
    // Network error — proceed normally
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  )
}

boot()
